import { House } from 'lucide-react';
import { msg } from '@/lib/i18n';
import { defineModule } from '../types';
import { homeAliasRoute, homeRoute } from './routes';

export { homeRoute } from './routes';

export const homeModule = defineModule({
  key: 'home',
  routes: [homeRoute, homeAliasRoute],
  nav: [
    {
      key: 'home',
      label: msg('Home'),
      description: msg('Today: briefing, attention inbox, key figures'),
      icon: House,
      to: '/',
      section: 'main',
      order: 0,
      match: ['/'],
    },
  ],
});
